var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGdrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_23830)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7240_23830",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 43,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01172 5H47.0118V47H5.01172V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7240_23830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01898 34.3337C9.22649 34.7568 9.05179 35.2679 8.62878 35.4754C8.20577 35.6829 7.69463 35.5082 7.48712 35.0852L9.01898 34.3337ZM15.4927 9.28905L15.9467 10.0113L15.9467 10.0114L15.4927 9.28905ZM7.48712 35.0852C2.89887 25.7321 6.02217 14.234 15.0387 8.56676L15.9467 10.0114C7.67713 15.2091 4.81117 25.7561 9.01898 34.3337L7.48712 35.0852ZM15.0387 8.56676C21.4983 4.50658 29.3431 4.4708 35.6376 7.78559L34.8425 9.29529C29.0645 6.25249 21.8701 6.28824 15.9467 10.0113L15.0387 8.56676Z",
    fill: "#8C8AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4767 16.7186C42.2445 16.3086 42.3887 15.788 42.7987 15.5559C43.2087 15.3237 43.7293 15.4679 43.9614 15.8779L42.4767 16.7186ZM36.5291 42.7602L36.0751 42.0379L36.0751 42.0379L36.5291 42.7602ZM43.9614 15.8779C49.3583 25.4094 46.3518 37.5939 36.9831 43.4825L36.0751 42.0379C44.6682 36.6368 47.4263 25.4603 42.4767 16.7186L43.9614 15.8779ZM36.9831 43.4825C30.242 47.7196 22.0014 47.5666 15.583 43.8013L16.4463 42.3296C22.3379 45.7858 29.8947 45.9226 36.0751 42.0379L36.9831 43.4825Z",
    fill: "#8C8AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5008 10.2958C41.5008 12.1988 39.9581 13.7415 38.0551 13.7415C36.1521 13.7415 34.6094 12.1988 34.6094 10.2958C34.6094 8.39285 36.1521 6.85017 38.0551 6.85017C39.9581 6.85017 41.5008 8.39285 41.5008 10.2958Z",
    fill: "#00D085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5485 41.0119C16.5485 42.9148 15.0058 44.4575 13.1029 44.4575C11.1999 44.4575 9.65723 42.9148 9.65723 41.0119C9.65723 39.1089 11.1999 37.5662 13.1029 37.5662C15.0058 37.5662 16.5485 39.1089 16.5485 41.0119Z",
    fill: "#FF6060"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7240_23830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 34.2704L16.1014 36.253C16.3389 36.6704 16.6808 36.9986 17.0824 37.2376L21.1827 34.3305L21.1902 30.1567L17.0984 28.3132L13 30.1421C12.9992 30.6037 13.1175 31.0655 13.355 31.4829L14.9583 34.2704Z",
    fill: "#0066DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0149 21.8262L26.2288 16.3894L21.9325 14.7307C21.53 14.9683 21.1869 15.2952 20.9479 15.7118L13.3598 28.8025C13.1208 29.219 13.0008 29.6804 13 30.142L21.1902 30.1566L26.0149 21.8262Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0151 21.8263L29.9508 19.709L30.1228 14.7454C29.7211 14.5064 29.2597 14.3865 28.7832 14.3856L23.2735 14.3757C22.797 14.3749 22.3351 14.5081 21.9326 14.7307L26.0151 21.8263Z",
    fill: "#00831E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8094 30.1739L21.1897 30.1567L17.082 37.2376C17.4837 37.4766 17.9451 37.5965 18.4216 37.5974L33.551 37.6244C34.0275 37.6252 34.4894 37.492 34.8919 37.2694L34.9078 32.5132L30.8094 30.1739Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8927 37.2695C35.2952 37.0319 35.6382 36.7049 35.8772 36.2884L36.3552 35.4703L38.6406 31.5282C38.8796 31.1117 38.9996 30.6503 39.0004 30.1886L34.2665 27.6978L30.8252 30.1741L34.8927 37.2695Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8741 22.2889L31.1035 15.73C30.866 15.3125 30.5241 14.9843 30.1224 14.7454L26.0146 21.8262L30.8096 30.1739L38.9848 30.1885C38.9857 29.7269 38.8673 29.2651 38.6298 28.8477L34.8741 22.2889Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_23830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0001,
    height: 42,
    fill: "white",
    transform: "translate(5 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7240_23830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGdrive);
export default __webpack_public_path__ + "static/media/icon_gdrive.d2f13d877f47e7ad19cbd5623ddda926.svg";
export { ForwardRef as ReactComponent };